
import { Component, Prop, Mixins } from 'vue-property-decorator';
import WhiteLabelMixin from '@/features/common/mixins/whiteLabelMixin';
import { AppTheme } from '../../constants';

@Component
export default class NavLogo extends Mixins(WhiteLabelMixin) {
  @Prop({ default: true }) withLink!: boolean;

  @Prop({ default: 'lg' }) size!: string;

  @Prop({ default: false }) mini!: boolean;

  @Prop({ default: false }) light!: boolean;

  @Prop({ default: false }) root!: boolean;

  get containerComponent(): string {
    if (this.root) return 'button';
    return this.withLink ? 'router-link' : 'span';
  }

  get logoName(): string {
    if (this.mini) return 'logo-mini';
    if (this.light) return 'logo-light';
    if (this.appTheme === AppTheme.Default && this.isPageWithoutNav) return 'logo-light';
    return 'logo';
  }

  get logoNameMadeInCanada(): string {
    if (this.mini) return 'logo-mini';

    const isEvenDay = new Date().getDate() % 2 === 0;

    if (this.light) {
      return isEvenDay ? 'logo-canada-mapple-only-light' : 'logo-canada-with-flag-light';
    }
    if (this.appTheme === AppTheme.Default && this.isPageWithoutNav) {
      return isEvenDay ? 'logo-canada-mapple-only-light' : 'logo-canada-with-flag-light';
    }
    return isEvenDay ? 'logo-canada-mapple-only' : 'logo-canada-with-flag';
  }

  get getSizeClass(): string {
    return `size-${this.size}`;
  }

  private goToLandingPage() {
    if (!this.root) return;
    window.location.assign('/');
  }
}
